<template>
	<layout width="300px">
		<template v-slot:left>
			<p class="fu" style="padding-top: 20px;">
				<svg t="1605852761368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3297" width="32" height="32"><path d="M512 624a112 112 0 1 0 0-224 112 112 0 0 0 0 224z" p-id="3298" fill="#8a8a8a"></path></svg>
				<span >工作台</span>
			</p>
		</template>
		<template v-slot:right>
			<router-view></router-view>
		</template>
	</layout>
</template>

<script>
	import layout from "../../components/layout.vue"
	// import detail from './component/detail.vue';
	export default {
		components: {
			layout,
			// detail
		},
		data() {
			return {
				leftTreeData: [], //左侧树数据
				formData: [],
			};
		},
		methods: {
			getRow(obj, fuObj) {
				console.log(obj)
				console.log(fuObj);
				// if (fuObj.level == 3) {
				// 	if (obj.name == "人才") {
				// 		this.$router.push(`/index/member/personnelInformation/${fuObj.parent.data.name}`)
				// 	}
				// 	if (obj.name == "管理员") {
				// 		this.$router.push(`/index/member/administrator/${obj.name}/${fuObj.parent.data.id}`)
				// 	}
				// 	return
				// }
				// if (fuObj.level == 2 && fuObj.childNodes.length==0) {
				// 	this.$router.push(`/index/member/administrator/${obj.name}/${obj.id}`)
				// 	return
					
				// }
				if(obj.label=='商户'){
					this.$router.push("/index/member/merchant")
					return
				}
				if(obj.label=='第三方服务人员'){
					this.$router.push("/index/member/servicePersonal")
					return
				}
			},
			getAll() {
				this.$http.get(`/api/system/dept/treeselect`).then(res => {
					console.log(res.data.data)
					// res.data.data.filter(item => {
					// 	return item.name == "业主"
					// })[0].children.forEach(item => {
					// 	item.bdDepts = [{
					// 		name: "管理员"
					// 	}, {
					// 		name: "人才"
					// 	}]
					// })
					this.leftTreeData = res.data.data
					
				})
			}
		},
		mounted() {
			//this.getAll();
		}
	};
</script>

<style scoped="scoped">
	.fu {
		display: flex;
		cursor: pointer;
		align-items: center;
		padding-bottom: 14px;
		font-size: 0.9rem;
	}
	
	.fu>span {
		color: #b0b0b0;
	}

</style>
